// extracted by mini-css-extract-plugin
export default {"bdtInfo":"BKash_bdtInfo__NI8CQ","billingAccountInput":"BKash_billingAccountInput__gCjEd","copyIcon":"BKash_copyIcon__rZanY"};